<template>
  <main-sidebar :name="name" :title="$t('new_expense') | capitalize">
    <div class="p-4">
      <vs-row v-if="activeManualExpense === 'true'">
        <vs-col>
          <vs-checkbox v-model="manualExpense" @change="handleChangeCheckboxManual" :disabled="isEditing">{{
            $t('manual_expense') }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <div v-if="!manualExpense">
        <!-- Begin Expense with XML -->
        <!-- <vs-row  vs-w="12" class="mb-2 mt-4">
          <vs-alert title="Aviso" color="danger" v-if="msg!=''">
            {{msg}}
          </vs-alert>
        </vs-row>
        <vs-row vs-w="12" class="mb-2 mt-4">
          <qb-upload ref="upload" multiple :showUploadButton="false" @on-delete="handleFileDelete" @update-file="handleFileUpdate" :limit="2" accept="application/xml,application/pdf" />
        </vs-row> -->
        <upload-expense-files ref="uploadExpenseFiles" @update="updateFiles" />
        <vs-row vs-w="12" class="mb-2 mt-4 ml-4">
          <vs-button color="primary" icon-pack="feather" icon="icon-upload" type="filled" class="mr-6 w-full"
            :disabled="!expenseFiles.status" @click="saveExpense">
            {{ $t('save') }}
          </vs-button>
        </vs-row>
      </div>
      <!-- End Expense with XML -->
      <!-- Begin Manual Expense -->
      <div v-else class="mt-4">
        <!-- Expense Date -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('date') }}</label>
          </vs-col>
          <vs-col vs-w="12" class="pl-1 mt-4">
            <datepicker placeholder="Expense Date" :format="format" v-model="expenseDate"></datepicker>
          </vs-col>
        </vs-row>
        <!-- Client Select -->
        <vs-row vs-w="12" class="mb-2 mt-4">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('client') }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" class="w-full">
            <v-select v-model="params.client_id" :options="clients" class="w-full" :reduce="(client) => client.ClientId"
              label="ClientName" @input="handleChangeClientSelect" />
          </vs-col>
        </vs-row>
         <!-- Departament Select -->
        <vs-row vs-w="12" class="mb-2 mt-4" v-if="params.client_id == '19' || params.client_id == '62' || params.client_id == '122'">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('departament') }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" class="w-full">
            <select
              v-model="params.departament_id"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in departaments"
                :key="i"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <!-- Company -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('company') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <vs-input class="w-full" v-model="params.company" disabled />
          </vs-col>
        </vs-row>
        <!-- Is this PO? -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <vs-checkbox v-model="isPO" @change="handleChangeCheckboxPO" v-if="!isEditing">¿Es PO?</vs-checkbox>
          </vs-col>
        </vs-row>
        <!-- DIV is PO -->
        <div v-show="isPO">
          <!-- Facility Select -->
          <vs-row v-if="params.client_id == null || params.client_id == ''">
            <vs-col>
              <label style="color: red">Selecciona Cliente</label>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-2 mt-4">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
              <label>{{ $tc('facility') }}</label>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" class="px-1">
              <v-select v-model="params.facility_id" :options="facilities" class="w-full"
                :reduce="(facility) => facility.id" label="name" />
            </vs-col>
          </vs-row>
        </div>
        <!--  -->
        <!-- Vendors -->

        <vs-row vs-w="12" class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('vendor') }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <v-select label="name" :filterable="false" :options="vendors" @search="onSearchVendors"
              v-model="params.vendor_id" class="w-full"></v-select>
          </vs-col>
        </vs-row>
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <add-vendor :paydays="paydays" :clients="clients" defaultType="1" @success="vendorAdded" />
          </vs-col>
        </vs-row>
        <!-- Account Number-->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('account') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <vs-input class="w-full" v-model="params.account" maxlength="10" />
          </vs-col>
        </vs-row>
        <!-- Categories -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <label>{{ $t('category') }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <!-- aqui -->
            <v-select v-model="params.category_id" :options="categories" class="w-full"
              :reduce="(category) => category.CategoryId" label="CategoryName" />
          </vs-col>
        </vs-row>

        <!-- Series y Folio-->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('series') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('folio') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="params.series" maxlength="10" />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="params.folio" maxlength="20" />
          </vs-col>
        </vs-row>
        <!-- Currency and IVA-->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('currency') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>IVA</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <v-select v-model="params.currency" :options="currencies" class="w-full"
              :reduce="(currency) => currency.value" label="name" :disabled="this.expenseItems.length > 0" />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <v-select v-model="params.iva" :options="taxes" class="w-full" :reduce="(tax) => tax.value" label="name"
              :disabled="this.expenseItems.length > 0" />
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('IVA') | capitalize }} {{ $t('retained') | capitalize }}
            </label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>
              {{ $t('ISR') | capitalize }}
              {{ $t('retained') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="params.retainedIva" />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="params.retainedIsr" />
          </vs-col>
        </vs-row>

        <!-- Expense Items -->
        <vs-divider></vs-divider>
        <vs-row>
          <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
            <h5>Expense Items</h5>
          </vs-col>
        </vs-row>
        <!-- Table Expense Items -->
        <vs-row>
          <vs-col vs-w="12">
            <expense-items-add :data="expenseItems" :subtotal="totalItems" :iva="(totalItems * params.iva) / 100"
              :total="totalItems + (totalItems * params.iva) / 100" @deleteItem="deleteItem" />
          </vs-col>
        </vs-row>
        <!-- Expense Items - Quantity, Unit Cost  -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('quantity') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <label>{{ $t('unit_cost') | capitalize }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="item.quantity" type="number" v-mask="'###'" />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6" class="px-1">
            <vs-input class="w-full" v-model="item.unit_cost" type="number" />
          </vs-col>
        </vs-row>
        <!-- Expense Items - Description -->
        <vs-row class="mb-2">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="11">
            <label>{{ $t('description') | capitalize }}</label>
          </vs-col>
          <vs-col vs-w="1"> </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="11">
            <vs-input class="w-full" v-model="item.description" />
          </vs-col>
          <vs-col vs-w="1">
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus" class="mx-2 w-full"
              @click="addExpenseItem"></vs-button>
          </vs-col>
        </vs-row>
        <!-- File -->
        <vs-row vs-w="12" class="mb-2 mt-4">
          <qb-upload ref="uploadManualPdf" :showUploadButton="false" @on-delete="handleManualFileDelete"
            @update-file="handleManualFileUpdate" :limit="1" accept="application/pdf" :reset="resetManualFile" />
        </vs-row>
        <!-- Hidden Inputs -->
        <vs-row>
          <vs-col>
            <vs-input class="w-full" :hidden="true" />
            <v-select :hidden="true" />
          </vs-col>
        </vs-row>
        <!-- Buttons -->
        <div class="mx-4" slot="footer">
          <vs-button color="primary" type="filled" class="mr-6" @click="submitManual" :disabled="isInvalidManual">
            <p v-if="!isEditing">{{ $t('submit') | capitalize }}</p>
            <p v-else>{{ $t('update') | capitalize }}</p>
          </vs-button>
          <vs-button color="primary" type="border" @click="close">
            {{ $t('cancel') }}
          </vs-button>
        </div>
      </div>
      <!-- End Manual Expense -->
    </div>

    <div class="mx-4"></div>
  </main-sidebar>
</template>
<script>
import ExpenseItemsAdd from '@/views/apps/expense/components/ExpenseItemsAdd.vue'
import UploadExpenseFiles from '@/views/apps/expense/components/UploadExpenseFiles'
import MainSidebar from '@/views/components/MainSidebar.vue'
import QbUpload from '@/components/upload/QbUpload.vue'
import AddVendor from '@/views/modules/vendors/home/components/AddVendor.vue'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import expense from '@/http/requests/expense'
import client from '@/http/requests/client'
import general from '@/http/requests/general'
import vendor from '@/http/requests/vendor'
import loading from '@/mixins/Loading.js'
import moment from 'moment'
import { PAYDAYS } from '@/const'
import debounce from 'lodash/debounce'
export default {
  components: {
    MainSidebar,
    QbUpload,
    vSelect,
    Datepicker,
    ExpenseItemsAdd,
    AddVendor,
    UploadExpenseFiles,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return (
        this.loading.clients ||
        this.loading.vendors ||
        this.loading.categories ||
        this.loading.submit ||
        this.loading.facilities ||
        this.loading.departaments ||
        this.loading.files
      )
    },
    submitDisabled() {
      return !this.isValid || this.msg != ''
    },
    totalItems() {
      let suma = Number(0)
      this.expenseItems.forEach((item) => {
        suma += item.unit_cost * item.quantity
      })
      return suma
    },
    isInvalidManual() {
      let facility = false
      let isValid = this.files.manual_pdf.data == ''
      if (this.isPO == true) {
        facility =
          this.params.facility_id == '' || this.params.facility_id == null
            ? true
            : false
      }

      if (this.isEditing) {
        isValid = false
      }
      return (
        this.params.folio == '' ||
        this.params.client_id == '' ||
        this.params.client_id == null ||
        this.params.category_id == '' ||
        this.params.category_id == null ||
        this.params.vendor_id == '' ||
        this.params.vendor_id == null ||
        this.params.currency == '' ||
        this.params.currency == null ||
        this.expenseItems.length == 0 ||
        this.params.retainedIva < 0 ||
        this.params.retainedIsr < 0 ||
        this.params.retainedIva == null ||
        this.params.retainedIsr == null ||
        this.params.retainedIva == '' ||
        this.params.retainedIsr == '' ||
        isValid ||
        facility
      )
    },
  },
  data() {
    return {
      clients: [],
      vendors: [],
      categories: [],
      facilities: [],
      currencies: [
        { value: 'MXN', name: 'MXN' },
        { value: 'USD', name: 'USD' },
      ],
      taxes: [
        { value: 0, name: '0 %' },
        { value: 8, name: '8 %' },
        { value: 16, name: '16 %' },
      ],
      departaments:[],
      params: {
        client_id: '',
        vendor_id: '',
        category_id: '',
        facility_id: '',
        departament_id:'',
        company: '',
        account: '',
        series: '',
        folio: '',
        expenseDate: moment().format('MM-DD-YYYY'),
        currency: 'USD',
        total: 0,
        iva: 8,
        retainedIva: 0,
        retainedIsr: 0
      },
      expenseItems: [],
      deletedItems: [],
      item: {
        ExpenseId: null,
        description: '',
        quantity: '',
        unit_cost: '',
      },
      format: 'MM/dd/yyyy',
      expenseDate: moment().format('MM-DD-YYYY'),
      manualExpense: false,
      isEditing: false,
      resetManualFile: false,
      name: 'accounting-new-expense',
      loading: {
        clients: false,
        submit: false,
        vendors: false,
        categories: false,
        facilities: false,
        files: false,
        departaments:false,
      },
      msg: '',
      isValid: false,
      isPO: false,
      files: {
        pdf: {
          name: '',
          data: '',
        },
        xml: {
          name: '',
          data: '',
        },
        manual_pdf: {
          name: '',
          data: '',
        },
      },
      activeManualExpense: process.env.VUE_APP_ACTIVE_MANUAL_EXPENSE,
      expenseFiles: {
        status: false,
        files: {
          xml: null,
          pdf: null,
          others: [],
        },
      },
      paydays: [],
    }
  },
  methods: {
    init() {
      this.manualExpense = false
      this.isValid = false
      this.msg = ''
      this.resetExpenseForm()
    },
    handleChangeCheckboxManual() {
      this.msg = ''
      if (this.manualExpense) {
        this.getClients()
        this.getCategories()
        this.getDepartaments()
        //this.getVendors()
        this.paydays = PAYDAYS
      }
    },
    handleChangeCheckboxPO() {
      if (
        this.params.client_id != null &&
        this.params.client_id != '' &&
        this.isPO == true
      ) {
        this.getFacilities()
      } else {
        this.params.facility_id = null
      }
    },
    handleChangeClientSelect() {
      if (this.params.client_id != null && this.params.client_id != '') {
        let selected_client = this.clients.filter((item) => {
          return item.ClientId == this.params.client_id
        })
        this.params.company = selected_client[0].CompanyName
      }

      if (this.isPO == true) {
        this.params.facility_id = null
        this.getFacilities()
      }
    },
    getClients() {
      this.loading.clients = true
      client
        .list({ all: true })
        .then((res) => {
          this.clients = res.data.clients
          this.loading.clients = false
        })
        .catch((err) => {
          this.loading.clients = false
        })
    },
    getCategories() {
      this.loading.categories = true
      expense
        .getCategories()
        .then((res) => {
          //aqui
          this.categories = []
          let options = [];
          options = res.data.categories

          if (this.$i18n.locale === 'es') {
            for (let i = 0; i < options.length; i++) {
              this.categories.push({ CategoryId: options[i].CategoryId, CategoryName: options[i].CategoryNameSp })
            }
          } else {
            for (let i = 0; i < options.length; i++) {
              this.categories.push({ CategoryId: options[i].CategoryId, CategoryName: options[i].CategoryName })
            }
          }
          this.loading.categories = false
        })
        .catch((err) => {
          this.loading.categories = false
          console.log(err)
        })
    },
    // getVendors() {
    //   this.loading.vendors = true
    //   vendor
    //     .list()
    //     .then((res) => {
    //       this.vendors = res.data.vendors
    //       this.loading.vendors = false
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       this.loading.vendors = false
    //     })
    // },
    getFacilities() {
      this.loading.facilities = true
      /*  let params={
        client_id:this.params.client_id
      } */
      general
        .getFacilities(this.params.client_id)
        .then((res) => {
          this.facilities = res.data.facilities
          this.loading.facilities = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.facilities = false
        })
    },
    clear() {
      this.$refs.uploadExpenseFiles.restart()
      this.isValid = false
      this.msg = ''
    },
    handleFileUpdate(e) {
      this.expenseFiles = { ...e }
      if (this.expenseFiles.status) {
        this.isValid = true
      }
    },
    handleFileDelete(e) {
      this.msg = ''
      this.isValid = false
      switch (e.type) {
        case 'application/pdf':
          this.files.pdf.data = ''
          this.files.pdf.name = ''
          break
        default:
          //e.type='text/xml'
          this.files.xml.data = ''
          this.files.xml.name = ''
          break
      }
    },
    handleManualFileUpdate(e) {
      let split_name = []
      this.msg = ''
      for (let i = 0; i < e.length; i++) {
        if (e[i].type === 'application/pdf') {
          if (this.files.pdf.data != '') {
            this.msg = 'Solo está permitido un archivo PDF'
          } else {
            split_name = String(e[i].name).split('.pdf')
            this.files.manual_pdf.data = e[i]
            this.files.manual_pdf.name = split_name[0]
          }
        }
      }
    },
    handleManualFileDelete(e) {
      this.msg = ''
      this.isValid = false
      this.files.manual_pdf.data = ''
      this.files.manual_pdf.name = ''
    },
    resetExpenseForm() {
      this.params = {
        client_id: '',
        departament_id:null,
        vendor_id: '',
        category_id: '',
        facility_id: '',
        company: '',
        account: '',
        series: '',
        folio: '',
        expenseDate: moment().format('MM-DD-YYYY'),
        currency: 'USD',
        total: 0,
        iva: 8,
        retainedIva: 0,
        retainedIsr: 0
      }
      this.expenseItems = []
      this.deletedItems = []
      this.item = {
        description: '',
        quantity: '',
        unit_cost: '',
      }
      this.files = {
        pdf: {
          name: '',
          data: '',
        },
        xml: {
          name: '',
          data: '',
        },
        manual_pdf: {
          name: '',
          data: '',
        },
      }
    },
    updateFiles(e) {
      this.expenseFiles = { ...e }
      // console.log('expenseFiles',this.expenseFiles)
    },
    validateFiles: function (files) {
      let size = 0
      if (files.pdf != null) {
        size += files.pdf.size / (1024 * 1024)
      }
      if (files.xml != null) {
        size += files.pdf.size / (1024 * 1024)
      }
      files.others.forEach(function (file, i) {
        size += file.size / (1024 * 1024)
      })
      if (size > 10) {
        this.$vs.notify({
          color: 'warning',
          title: 'Alert',
          text: 'Max. 10 MB.',
        })
        return false
      }
      return true
    },
    saveExpense() {
      if (!this.validateFiles(this.expenseFiles.files)) {
        return
      }
      this.loading.files = true
      const data = new FormData()
      data.append('xml', this.expenseFiles.files.xml)
      data.append('pdf', this.expenseFiles.files.pdf)
      this.expenseFiles.files.others.forEach(function (file, i) {
        data.append('other[]', file)
      })
      this.isValid = false
      expense
        .saveExpense(data)
        .then((res) => {
          if (res.data.status == true) {
            this.clear()
            this.close()
            this.$emit('success')
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: res.data.msg,
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: res.data.msg,
            })
          }
          this.isValid = true
          this.loading.files = false
        })
        .catch((err) => {
          if (422 === err.response.status) {
            console.log(err.response)
            this.msg = err.response.data.msg
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
          this.isValid = true
          this.loading.files = false
          //this.files = []
        })
    },
    submitManual() {
      let fileSize = this.files.manual_pdf.data.size / (1024 * 1024)
      if (fileSize > 10) {
        this.$vs.notify({
          color: 'warning',
          title: 'Alert',
          text: 'Max. 10 MB.',
        })
        return
      }
      if((this.params.client_id == '19' || this.params.client_id == '62' || this.params.client_id == '122') && (this.params.departament_id == null || this.params.departament_id == '')){
       this.$vs.notify({
          color: 'warning',
          title: 'Alert',
          text: 'Select Departament',
        }) 
        return 
      }
      this.loading.submit = true
      let params = new FormData()
      params.append('pdf', this.files.manual_pdf.data)
      params.append('isPO', this.isPO)
      params.append('client_id', this.params.client_id)
      params.append('departament_id', this.params.departament_id)
      params.append('folio', this.params.folio)
      params.append('currency', this.params.currency)
      params.append('account', this.params.account)
      params.append('series', this.params.series)
      if (this.isPO == true) {
        params.append('facility_id', this.params.facility_id)
      }
      params.append('vendor_id', this.params.vendor_id.id)
      params.append('iva', this.params.iva)
      params.append('ivaTotal', (this.totalItems * this.params.iva) / 100)
      params.append('subtotal', this.totalItems)
      params.append('total', this.totalItems + (this.totalItems * this.params.iva) / 100)
      params.append('category_id', this.params.category_id)
      params.append('company', this.params.company)
      params.append('expense_items', JSON.stringify(this.expenseItems))
      params.append('retainedIva', this.params.retainedIva)
      params.append('retainedIsr', this.params.retainedIsr)
      this.formatDatesToDB()
      params.append('expenseDate', this.params.expenseDate)
      if (!this.isEditing) {
        expense
          .createManualExpense(params)
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Gasto Manual Creado',
            })
            this.$emit('success')
            this.loading.submit = false
            this.close()
          })
          .catch((err) => {
            if (422 === err.response.status) {
              console.log(err.response)
              this.msg = err.response.data.msg
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: 'SERVER ERROR',
              })
            }
            this.loading.submit = false
          })
      } else {
        params.append('ExpenseId', this.params.expense_id)
        params.append('deletedItems', JSON.stringify(this.deletedItems))
        expense
          .updateExpenseManual(params)
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Gasto Manual Actualizado',
            })
            this.$emit('success')
            this.loading.submit = false
            this.close()
          })
          .catch((err) => {
            if (422 === err.response.status) {
              console.log(err.response)
              this.msg = err.response.data.msg
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: 'SERVER ERROR',
              })
            }
            this.loading.submit = false
          })
      }
    },
    addExpenseItem() {
      let suma = Number(0)
      this.expenseItems.forEach((item) => {
        suma += item.unit_cost * item.quantity
      })

      let item = Object.assign({}, this.item)
      this.expenseItems.push(item)
      this.item.ExpenseId = null
      this.item.description = ''
      this.item.quantity = ''
      this.item.unit_cost = ''
      this.params.total = suma
    },
    deleteItem(index) {
      if (this.isEditing) {
        if (this.expenseItems[index].ItemId != undefined) {
          this.deletedItems.push({
            ExpenseId: this.expenseItems[index].ExpenseId,
            ItemId: this.expenseItems[index].ItemId,
          })
        }
      }
      this.expenseItems.splice(index, 1)
    },
    formatDatesToDB() {
      this.params.expenseDate = moment(this.expenseDate).format('YYYY-MM-DD')
    },
    vendorAdded(vendor) {
      // this.getVendors()
      this.params.vendor_id = {
        id: vendor.id,
        name: vendor.name,
        cateogry_contract_id: vendor.cateogry_contract_id
      }
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    onSearchVendors(search, loading) {
      if (search.length > 3) {
        loading(true);
        this.getVendors(loading, search, this);
      }
    },
    getVendors: debounce((loading, search, vm) => {
      vendor
        .search({ search: search })
        .then((res) => {
          vm.vendors = [...res.data.vendors]
          loading(false);
        })
        .catch((err) => {
          vm.vendors = []
          loading(false);
        })
    }),
    getDepartaments() {
      this.loading.departaments = true
      expense
        .getDepartaments()
        .then((response) => {
          this.departaments = [...response.data]
          this.loading.departaments = false
        })
        .catch((error) => {
          this.loading.departaments = false
          this.showValidationErrors(error)
        })
    },
  },
  mixins: [loading],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        if (Object.entries(this.data).length === 0) {
          this.init()
          this.isEditing = false
          this.clear()
          this.expenseFiles = Object.assign({}, {
            status: false,
            files: {
              xml: null,
              pdf: null,
              others: []
            }
          })
        } else {
          this.deletedItems = []
          this.manualExpense = true
          this.isEditing = true
          this.resetManualFile = !this.resetManualFile
          this.files.manual_pdf.data = ''
          this.files.manual_pdf.name = ''
          this.handleChangeCheckboxManual()
          const {
            ExpenseId,
            ClientId,
            VendorId,
            vendor_name,
            CategoryId,
            departament_budget_id,
            Folio,
            Series,
            CurrencyId,
            AccountNumber,
            ExpenseDate,
            CompanyName,
            iva,
            RetainedIva,
            RetainedISR,
          } = JSON.parse(JSON.stringify(this.data))
          this.params.expense_id = ExpenseId
          this.params.client_id = ClientId
          this.params.departament_id = departament_budget_id
          this.params.vendor_id = { name: vendor_name, id: VendorId }
          this.params.category_id = CategoryId
          this.params.folio = Folio
          this.params.series = Series
          this.params.currency = CurrencyId
          this.params.company = CompanyName
          this.params.account = AccountNumber
          this.params.retainedIva = RetainedIva
          this.params.retainedIsr = RetainedISR
          if (Number(iva) > 15 && Number(iva) < 17) {
            this.params.iva = 16
          } else if (Number(iva) > 7 && Number(iva) < 9) {
            this.params.iva = 8
          } else if (Number(iva) == 0) {
            this.params.iva = 0
          } else {
            this.params.iva = 8
          }
          this.expenseDate = new Date(ExpenseDate).toLocaleDateString('en-US')

          let suma = Number(0)
          this.expenseItems = []
          this.data.Items.forEach((elemento) => {
            let item = {
              description: elemento.Description,
              quantity: Number(elemento.Quantity),
              unit_cost: Number(elemento.UnitPrice),
              //
              Amount: Number(elemento.Amount),
              ExpenseId: elemento.ExpenseId,
              ItemId: elemento.ItemId,
              TypeId: elemento.TypeId,
              Unit: elemento.Unit,
              ProductId: elemento.ProductId,
            }
            suma += item.unit_cost * item.quantity
            this.expenseItems.push(item)
          })

          this.params.total = suma
        }
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  }
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}
</style>
